/**
 * Shared World Courier template country normalization.
 *
 * Single source of truth for mapping legacy country strings (full names /
 * aliases stored before 3-letter codes were used) to the WC portal's 3-letter
 * code. Imported by both BookShipmentDrawer (to populate the country select from
 * a template) and wcBookingTemplateAutosave (to compare + store canonically),
 * so seed data, form values, and stored rows dedupe consistently.
 */
export const LEGACY_COUNTRY_TO_CODE: Record<string, string> = {
  'united states': 'USA',
  usa: 'USA',
  canada: 'CAN',
  'united kingdom': 'GBR',
  uk: 'GBR',
  mexico: 'MEX',
};

/** Coerce a raw country string to the WC portal 3-letter code when known.
 *  Returns `undefined` for empty input; unknown values are returned trimmed. */
export function coerceLegacyCountryCode(
  raw: string | null | undefined
): string | undefined {
  if (!raw) return undefined;
  const t = raw.trim();
  if (!t) return undefined;
  return LEGACY_COUNTRY_TO_CODE[t.toLowerCase()] ?? t;
}

/** Canonical country string for equality/storage. Empty input → ''. */
export function normalizeWcTemplateCountry(
  raw: string | null | undefined
): string {
  return coerceLegacyCountryCode(raw) ?? '';
}
